import React from 'react';

import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import { useSelector } from 'editor/src/store/hooks';

import Tab from 'editor/src/component/DesktopSidebar/Tabs/Tab/index';
import IconGrid from 'editor/src/component/Icon/IconGrid';

function GangSheetTab() {
  const gangSheetSettings = useSelector((state) => state.hostSettings.gangSheet);

  if (!gangSheetSettings) {
    return null;
  }
  return (
    <Tab
      key={TAB_NAMES.GANG_SHEET}
      name={TAB_NAMES.GANG_SHEET}
      title="Gang sheet" // TODO: Lokalino
      icon={<IconGrid />}
    />
  );
}

export default React.memo(GangSheetTab);
